import { Injectable } from '@angular/core';
import { IStoreBase } from '@boxx/core';
import {
  IMessagesStateSuccess,
  IMessagesStateError,
} from '@boxx/messages-core';
import { Store } from '@ngrx/store';
import * as fromNotificationsActions from '../actions/notifications.actions';
import * as fromReducer from '../messages.reducer';
import * as fromNotificationsSelector from '../selectors/notifications.selectors';

@Injectable()
export class NotificationsStore
  implements
    IStoreBase<any[], IMessagesStateSuccess, IMessagesStateError>
{
  constructor(public store: Store<fromReducer.MessagesState>) {}

  get state$() {
    return this.store.select(fromNotificationsSelector.notificationsState);
  }
  get data$() {
    return this.store.select(fromNotificationsSelector.notificationsData);
  }
  get loading$() {
    return this.store.select(fromNotificationsSelector.notificationsIsLoading);
  }
  get success$() {
    return this.store.select(fromNotificationsSelector.notificationsSuccess);
  }
  get error$() {
    return this.store.select(fromNotificationsSelector.notificationsError);
  }
  get fetched$() {
    return this.store.select(fromNotificationsSelector.notificationsHasBeenFetched);
  }

  fetch() {
    this.store.dispatch(fromNotificationsActions.getNotificationsBeginAction());
  }

  setAsRead(id: number) {
    this.store.dispatch(fromNotificationsActions.setNotificationAsReadBeginAction({ id }));
  }

}
